<template>
  <v-col :cols="colSize">
    <v-subheader class="text-left text-xl-h5 text-lg-h5 text-md-h5 text-sm-h6">
      {{ title }}
    </v-subheader>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
    />
    <v-divider />
  </v-col>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    colSize: function () {
      return this.$vuetify.breakpoint.width > 500 ? '11' : '12'
    }
  }
}
</script>
